import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AddSectionComponent } from '../../../sections/add-section/add-section.component';
import { SectionComponent } from '../../../sections/section/section.component';
import { Article, Section } from '../../../../shared/public-api';

@Component({
  selector: 'admin-article-sections',
  templateUrl: './article-sections.component.html',
  styleUrls: ['./article-sections.component.scss'],
  imports: [CommonModule, ConfirmDialogModule, DialogModule, SectionComponent, AddSectionComponent],
  providers: [ConfirmationService],
})
export class ArticleSectionsComponent implements OnInit {
  @Input() articleModel: Article;
  @Output() articleModelChange = new EventEmitter<Article>();

  showAddSectionModal: boolean;
  newSectionOrder?: number;

  constructor(private confirmationService: ConfirmationService) {}

  ngOnInit(): void {}

  addSection($event: Section<any>): void {
    $event.sectionData = {};
    if (this.articleModel.sections) {
      const insertIndex = this.newSectionOrder ?? this.articleModel.sections.length;
      this.articleModel.sections.splice(insertIndex, 0, $event);
      this.newSectionOrder = undefined;
      this.showAddSectionModal = false;
    }
  }

  updateSectionOrder(section: Section<any>, direction: number): void {
    const index = this.articleModel.sections!.indexOf(section);
    this.articleModel.sections!.splice(index, 1);
    const newIndex = index + direction;
    this.articleModel.sections!.splice(newIndex, 0, section);
  }

  deleteSection(section: Section<any>): void {
    this.confirmationService.confirm({
      message: 'Etes-vous sur de supprimer cette section?',
      header: 'Supprimer une section',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.removeSection(section),
    });
  }

  openSectionModal(order?: number): void {
    this.showAddSectionModal = true;
    this.newSectionOrder = order;
  }

  private removeSection(section: Section<any>): void {
    const index = this.articleModel.sections!.indexOf(section);
    this.articleModel.sections!.splice(index, 1);
  }
}
